// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dE7h","type":"styles_type__17Ljm","choices":"styles_choices__1Malr"};